<template>
    <div>
        <h2 class="single-diamond-configurator__heading">{{ $t('singleDiamondsConfigurator.clarityDiagramHeading') }}</h2>
        <img
            :src="$t('diagrams.clarityLink')"
            :alt="$t('singleDiamondsConfigurator.clarityDiagramHeading')"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "DiamondClarityDiagram"
});
</script>

<style scoped>
img {
    display: block;
    max-width: 100%;
}

@media screen and (max-width: 1280px) {
    h2 {
        display: none;
    }
}
</style>
